import { createContext, useContext } from 'react';

export interface ScrollContextType {
  isScrolled: boolean;
  isInnerPage: boolean;
  isMoving: boolean; // True while the user is actively scrolling up OR down
}

export const ScrollContext = createContext<ScrollContextType | undefined>(undefined);

export const useScrollContext = () => {
  const context = useContext(ScrollContext);
  if (!context) throw new Error('useScrollContext must be used within a ScrollProvider');
  return context;
};
